import React from 'react';
import {FormDialog, RaymanUser, UserSize} from 'components/core';
import {UsersCtx} from 'components/dataProviders/users';
import {TagsCtx} from 'components/dataProviders/tags';
import {OperationsCtx} from 'components/dataProviders/operations';
import Singletons from 'controllers/Singletons';


export default function Create({open, onClose})
{
    const usersCtx = React.useContext(UsersCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const opsCtx = React.useContext(OperationsCtx);
    const [loading, setLoading] = React.useState(false);
    const [expertItems, setExpertItems] = React.useState([]);
    const [tagItems, setTagItems] = React.useState([]);

    React.useEffect(function InitializeExperts(){
        let experts = [];
  
        usersCtx.data.profiles.experts.forEach((item) => {
          if(item.userID === Singletons.currentUser.userID) return;
          experts.push(
            {
              value: item.userID,
              content: <RaymanUser userID={item.userID} size={UserSize.size24} />
            }
          )
        });
  
        setExpertItems(experts);
      }, [usersCtx]);

      React.useEffect(function initializeTags() {
        let tags = [];
        tagsCtx.data.active.forEach((item) => tags.push({value: item.tagID, content: item.name}));
  
        setTagItems(tags);
    }, [tagsCtx]);

    const handleClose = () => {
        if(onClose) onClose();
      };
  
      const handleConfirm = (values) => {
        values.users = {
          experts: values.expert,
          operators: Singletons.currentUser.userID
        }
        delete values.expert;
        setLoading(true);
        opsCtx.funcs.create(values).then(() => {
          setLoading(false);
          handleClose();
        });
      }

    return <FormDialog
    open={open}
    onClose={handleClose}
    onConfirm={handleConfirm}
    title="Crear Ticket"
    subtitle="Añade un nombre al ticket y selecciona a un operador"
    confirm="Crear ticket"
    cancel="Cancelar"
    loading={loading}
    fields={[
      {
        type: "text",
        label: "Nombre del ticket",
        id: "name",
        placeholder: "",
        mandatory: true,
        value: ''
      },
      {
        type: "selector",
        label: "Seleccionar experto remoto",
        id: "expert",
        mandatory: true,
        value: '',
        items: expertItems
      },
      {
        type: "tagSelector",
        label: "Añadir etiquetas",
        id: "tags",
        value: [],
        items: tagItems
      }
    ]}
    />
}